var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-list m-t-20"},[(_vm.spaces)?_c('div',_vm._l((_vm.filteredSpaces),function(space){return _c('EventItem',{key:space.space_id,attrs:{"space":space},on:{"bookEvent":_vm.book}})}),1):_c('div',{staticClass:"flexed justify-center align-center"},[_c('loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }